import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { rutlandConfig } from "./data";

export default function RutlandPage() {
  return <CityPageTemplate config={rutlandConfig} />;
}